export default "__VITE_ASSET__CB4$Vu_r__"